<template>
  <div>
    <Button
      type="button"
      label="Vinculación Manual"
      iconPos="right"
      class="p-button-link"
      @click="toggle"
    />

    <OverlayPanel
      ref="op"
      :style="{ width: '450px' }"
      :showCloseIcon="true"
      :test-id="'OverlayPanelVinculacionManual'"
    >
      <div
        class="flex justify-content-center flex-wrap card-container"
        :test-id="'divContenedorOverlayPanelVinculacionManual'"
      >
        <h3>Ingreso manual de los datos.</h3>
        <TabView class="w-25rem">
          <TabPanel header="Sumarios">
            <div
              class="flex flex-column w-11 justify-content-center"
              :test-id="'divContenedorCamposOverlayPanelVinculacionManual'"
            >
              <p>Nro.Actuación</p>
              <InputText
                class=""
                v-model="dataNumeroActuacion"
                placeholder="Nro.Actuación"
                :test-id="'InputNroActuacion'"
              />
              <p>Juzgado Interviniente</p>
              <InputText
                class=""
                v-model="dataJuzgadoInterviniente"
                placeholder="Juzgado Interviniente"
                :test-id="'InputJuzgadoInterviniente'"
              />
              <p>Causa Carátula</p>
              <InputText
                class=""
                v-model="dataCaratula"
                placeholder="Causa Carátula"
                :test-id="'InputCaratula'"
              />
              <p>Dependencia donde se realizó el sumario</p>
              <InputText
                class=""
                v-model="dataDependencia"
                placeholder="Dependencia donde se realizó el sumario"
                :test-id="'InputDependencia'"
              />
              <p>Tipo de Actuación</p>

              <Dropdown
                dataKey="Nombre"
                v-model="tipoFormulario"
                optionLabel="Nombre"
                :options="tiposSumariosList"
                optionValue="Nombre"
                placeholder="Formulario"
                class="flex"
                :filter="true"
                :test-id="'DropTipoActuacion'"
              />
            </div>
            <Button
              label="Agregar"
              class="p-button-sm mt-4 mb-2 w-12"
              @click="addVinculo"
              test-id="btnAgregarVinculoSumarios"
              :disabled="actuationValidations.buttonDisabled"
            />
          </TabPanel>
          <TabPanel header="Infracciones">
            <div
              class="flex flex-column w-11 justify-content-center"
              :test-id="'divContenedorCamposOverlayPanelVinculacionManualInfracciones'"
            >
              <p>Fecha de la Infracción</p>
              <CustomCalendar
                id="time24"
                class="input"
                :selectOtherMonths="true"
                onkeydown="return false"
                :showTime="true"
                placeholder="Fecha de la Infracción"
                dateFormat="dd/mm/yy"
                v-model="dataInfractionDate"
                :maxDate="today"
                test-id="desdeCalendar"
                :baseZIndex="999999"
                :timeByKeyboard="true"
              />
              <p>Nro. Infracción</p>
              <InputText
                class=""
                v-model="infractionNumber"
                placeholder="Nro. Infracción"
                :test-id="'InputNroInfraccion'"
              />
              <p>Juzgado Asignado</p>
              <InputText
                class=""
                v-model="infractionJuzgadoInterviniente"
                placeholder="Juzgado Asignado"
                :test-id="'InputJuzgadoInterviniente'"
              />
            </div>
            <Button
              label="Agregar"
              class="p-button-sm mt-4 mb-2 w-12"
              @click="addVinculoInfraction"
              test-id="btnAgregarVinculoInfracciones"
              :disabled="infractionValidations.buttonDisabled"
            />
          </TabPanel>
        </TabView>
      </div>
    </OverlayPanel>
  </div>
</template>

<script setup>
import { computed, onMounted, reactive, ref, watch } from "vue";
import axios from "axios";
import OverlayPanel from "primevue/overlaypanel";
import CustomCalendar from "./custom-calendar/CustomCalendar.vue";

const emit = defineEmits(["event"]);

const op = ref(null);
const sumarios = ref({ data: { data: [] } });
const filteredFormulario = ref([]);
const formulario = ref("");
const tiposSumariosList = ref([]);
const numeroActuacion = ref("");
const juzgadoInterviniente = ref("");
const caratula = ref("");
const dependencia = ref("");
const tipoActuacion = ref("");
const infractionDate = ref("");
const infractionNumber = ref("");
const infractionJuzgadoInterviniente = ref("");
const idSumario = ref(null);

const infractionValidations = reactive({
  items: [
    { field: "infractionNumber", minLength: 2 },
    { field: "infractionJuzgadoInterviniente", minLength: 2 },
    { field: "infractionDate", emptyString: true },
  ],
  buttonDisabled: true,
});

const actuationValidations = reactive({
  items: [
    { field: "juzgadoInterviniente", minLength: 2 },
    { field: "numeroActuacion", minLength: 2 },
    { field: "caratula", minLength: 2 },
    { field: "dependencia", minLength: 2 },
    { field: "tipoFormulario", emptyString: true },
  ],
  buttonDisabled: true,
});

const validations = {
  infractionValidations,
  actuationValidations,
};

function getValidationFields() {
  return {
    numeroActuacion,
    juzgadoInterviniente,
    caratula,
    dependencia,
    tipoFormulario: formulario,
    infractionDate,
    infractionNumber,
    infractionJuzgadoInterviniente,
  };
}

function getAvailableFormularios() {
  return sumarios.value?.data?.data || [];
}

function evaluateCharactersLimit(dataToEvaluate, charactersLimit) {
  return dataToEvaluate.length > charactersLimit;
}

function evaluateIfUseNaNCharacters(dataToEvaluate) {
  return dataToEvaluate.split("").some((character) => Number.isNaN(parseInt(character, 10)));
}

function formatDate(originalDate) {
  const date = new Date(originalDate);
  const year = date.getFullYear();
  const month = `0${date.getMonth() + 1}`.slice(-2);
  const day = `0${date.getDate()}`.slice(-2);
  const hours = `0${date.getHours()}`.slice(-2);
  const minutes = `0${date.getMinutes()}`.slice(-2);
  const seconds = `0${date.getSeconds()}`.slice(-2);

  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}

function validateLength(validationKey) {
  const targetValidation = validations[validationKey];
  const allValid = targetValidation.items.every((item) => {
    const fieldValue = getValidationFields()[item.field].value;

    if ("minLength" in item) {
      return fieldValue.length > item.minLength;
    }
    if ("emptyString" in item) {
      return fieldValue !== "";
    }

    throw new Error(`Invalid item properties in ${item.field}`);
  });

  targetValidation.buttonDisabled = !allValid;
}

function resetInputs() {
  formulario.value = "";
  numeroActuacion.value = "";
  juzgadoInterviniente.value = "";
  caratula.value = "";
  dependencia.value = "";
  tipoActuacion.value = "";
  infractionDate.value = "";
  infractionNumber.value = "";
  infractionJuzgadoInterviniente.value = "";
  idSumario.value = null;
  infractionValidations.buttonDisabled = true;
  actuationValidations.buttonDisabled = true;
}

function selecFormulario() {
  if (typeof formulario.value !== "object") {
    const [selectedFormulario] = getAvailableFormularios().filter(
      (item) => item.Nombre.toLowerCase().search(formulario.value.toLowerCase()) >= 0
    );

    formulario.value = selectedFormulario?.Nombre || "";
    idSumario.value = selectedFormulario?.TiposumarioID ?? null;
  }
}

function filterFormulario(event) {
  filteredFormulario.value = getAvailableFormularios().filter(
    (item) => item.Nombre.toLowerCase().search(event.query.toLowerCase()) >= 0
  );
}

function toggle(event) {
  op.value?.toggle(event);
}

function addVinculo() {
  const objet = {
    Tipo: "actuacion",
    NumeroActuacion: numeroActuacion.value,
    JuzgadoInterviniente: juzgadoInterviniente.value,
    Caratula: caratula.value,
    DependenciaActuacion: dependencia.value,
    TipoActuacion: formulario.value,
    url: "/vinculo-actuacion-deposito/",
    NumeroVinculacion: numeroActuacion.value,
  };

  op.value?.hide();
  resetInputs();
  emit("event", objet);
}

function addVinculoInfraction() {
  const objet = {
    Tipo: "infraccion",
    FechaInfraccion: formatDate(infractionDate.value),
    NumeroInfraccion: infractionNumber.value,
    JuzgadoAsignado: infractionJuzgadoInterviniente.value,
    url: "/vinculo-infraccion-deposito",
    NumeroVinculacion: infractionNumber.value,
  };

  op.value?.hide();
  resetInputs();
  emit("event", objet);
}

const abc = computed(() => sumarios.value?.data?.data || []);
const today = computed(() => new Date());

const tipoFormulario = computed({
  get() {
    return formulario.value;
  },
  set(value) {
    formulario.value = value;
    selecFormulario();
    validateLength("actuationValidations");
  },
});

const dataInfractionDate = computed({
  get() {
    return infractionDate.value;
  },
  set(value) {
    infractionDate.value = value;
    validateLength("infractionValidations");
  },
});

const dataJuzgadoInterviniente = computed({
  get() {
    return juzgadoInterviniente.value;
  },
  set(value) {
    juzgadoInterviniente.value = value;
    validateLength("actuationValidations");
  },
});

const dataNumeroActuacion = computed({
  get() {
    return numeroActuacion.value;
  },
  set(value) {
    numeroActuacion.value = value;
    validateLength("actuationValidations");
  },
});

const dataCaratula = computed({
  get() {
    return caratula.value;
  },
  set(value) {
    caratula.value = value;
    validateLength("actuationValidations");
  },
});

const dataDependencia = computed({
  get() {
    return dependencia.value;
  },
  set(value) {
    dependencia.value = value;
    validateLength("actuationValidations");
  },
});

watch(infractionNumber, (newValue, oldValue) => {
  const newValueIsNaN = evaluateIfUseNaNCharacters(newValue);
  const charactersLimitExceeded = evaluateCharactersLimit(newValue, 30);

  if (newValueIsNaN || charactersLimitExceeded) {
    infractionNumber.value = oldValue;
  }

  validateLength("infractionValidations");
});

watch(infractionJuzgadoInterviniente, (newValue, oldValue) => {
  const charactersLimitExceeded = evaluateCharactersLimit(newValue, 50);

  if (charactersLimitExceeded) {
    infractionJuzgadoInterviniente.value = oldValue;
  }

  validateLength("infractionValidations");
});

onMounted(async () => {
  try {
    sumarios.value = await axios.get(
      `${process.env.VUE_APP_BACKEND_ENVIRONMENT}/parametros/tipo-actuacion/`,
      { withCredentials: true }
    );

    tiposSumariosList.value = getAvailableFormularios().filter(
      (item) => item.Nombre !== "Unidades Fiscales de Investigacion"
    );
  } catch (error) {
    console.error("Error al cargar tipos de actuacion para vinculacion manual", error);
    sumarios.value = { data: { data: [] } };
    tiposSumariosList.value = [];
  }
});

defineExpose({
  op,
  sumarios,
  filteredFormulario,
  formulario,
  tiposSumariosList,
  numeroActuacion,
  juzgadoInterviniente,
  caratula,
  dependencia,
  tipoActuacion,
  infractionDate,
  infractionNumber,
  infractionJuzgadoInterviniente,
  idSumario,
  infractionValidations,
  actuationValidations,
  abc,
  tipoFormulario,
  today,
  dataInfractionDate,
  dataJuzgadoInterviniente,
  dataNumeroActuacion,
  dataCaratula,
  dataDependencia,
  addVinculo,
  addVinculoInfraction,
  resetInputs,
  selecFormulario,
  filterFormulario,
  toggle,
  evaluateCharactersLimit,
  evaluateIfUseNaNCharacters,
  formatDate,
  validateLength,
});
</script>

<style scoped></style>
